export const Globals = Object.freeze({
  CACHE_TIME_BASE_DATA: 1800, // 1800
  USE_LANDING_PAGE: 1,
  USE_BREADCRUMB: 0,
  PUBLICATION: 'NCRV'
});
